import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import AddEmployerCoverageModal from '../../components/ssap/modals/AddEmployerCoverageDetailsModal';
import AddIncomeOrDeductionSourceModal from '../../components/ssap/modals/AddIncomeOrDeductionSourceModal';
import AddHraDetailsModal from '../../components/ssap/modals/AddHraDetailsModal';
import DeceasedMemberModal from '../../components/ssap/modals/DeceasedMemberModal';
import ExpectedIncomeModal from '../../components/ssap/modals/ExpectedIncomeModal';
import ExtraModal from '../../components/ssap/modals/ExtraModal';
import IndependentTaxFilersModal from '../../components/ssap/modals/IndependentTaxFilersModal';
import InformLawfullyPresenceRequiredForCoverageModal from '../../components/ssap/modals/InformLawfullyPresenceRequiredForCoverageModal';
import InformMedicareEligibleModal from '../../components/ssap/modals/InformMedicareEligibleModal';
import InformToAddIncomeSourceModal from '../../components/ssap/modals/InformToAddIncomeSourceModal';
import LeavePageModal from '../../components/ssap/modals/LeavePageModal';
import LocateAssistanceModal from '../../components/common/modals/LocateAssistanceModal';
import MandatorySeekingForCoverageModal from '../../components/ssap/modals/MandatorySeekingForCoverageModal';
import MultiTaxHouseholdModal from '../../components/ssap/modals/MultiTaxHouseholdModal';
import OtherAddressModal from '../../components/ssap/modals/OtherAddressModal';
import RemoveMemberModal from '../../components/ssap/modals/RemoveMemberModal';
import SsapExitModal from '../../components/ssap/modals/SsapExitModal';
import UndoMemberRemovalModal from '../../components/ssap/modals/UndoMemberRemovalModal';
import ValidateAddressModal from '../../components/ssap/modals/ValidateAddressModal';

// ActionCreators

import { changeData, fetchCountiesForZipcode, setCounty } from '../../actions/ssap/ssapActionCreators';

// Utils

import { getCurrentHouseholdMember } from '../../utils/householdMember/getCurrentHouseholdMember';


// Constants

import { ssapModalTypes as MODAL_TYPES } from '../../constants/ssap/modals/ssapModalTypes';


/**
 *
 * @param {Object} props - contains "modal" props from Redux Store
 * @returns {React.Component} - modal layout and needed content for Modal
 *
 */
const SsapModalContainer = props => {

    let {
        adjustedFlow,
        actions,
        counties,
        data,
        environment,
        form,
        householdMembers,
        hyperReview,
        methods,
        modal,
        modal: {
            modalType
        },
        page,
        ssapActions: {
            changeData,
            fetchCountiesForZipcode,
            setCounty
        },
        ...restProps
    } = props;

    const {
        hhmIndex,
        currentHhm
    } = getCurrentHouseholdMember(adjustedFlow, page, householdMembers);

    const actionsForOtherAddressModal = {
        fetchCountiesForZipcode,
        setCounty
    };

    actions = {
        ...actions,
        changeData
    };


    const extendedProps = {
        ...restProps,
        actions,
        counties,
        currentHhm,
        data,
        hhmIndex,
        householdMembers,
        hyperReview,
        methods,
        modal
    };

    const getModal = () => {
        switch (modalType) {

            case MODAL_TYPES.ADD_EMPLOYER_COVERAGE_DETAIL_MODAL:
                return <AddEmployerCoverageModal {...extendedProps }/>;

            case MODAL_TYPES.ADD_INCOME_OR_DEDUCTION_SOURCE_MODAL:
                return <AddIncomeOrDeductionSourceModal {...{ ...extendedProps, environment, form }}/>;

            case MODAL_TYPES.ADD_HRA_DETAIL_MODAL:
                return <AddHraDetailsModal {...extendedProps }/>;

            case MODAL_TYPES.DECEASED_MEMBER_MODAL:
                return <DeceasedMemberModal {...{ ...extendedProps }} />;

            case MODAL_TYPES.EXPECTED_INCOME_MODAL:
                return <ExpectedIncomeModal {...{ ...extendedProps }}/>;

            case MODAL_TYPES.INDEPENDENT_TAX_FILERS_MODAL:
                return <IndependentTaxFilersModal {...extendedProps }/>;

            case MODAL_TYPES.INFORM_MEDICARE_ELIGIBLE_MODAL:
                return <InformMedicareEligibleModal { ...{ ...extendedProps, environment } }/>;

            case MODAL_TYPES.INFORM_LAWFULLY_PRESENCE_REQUIRED_FOR_COVERAGE_MODAL:
                return <InformLawfullyPresenceRequiredForCoverageModal {...extendedProps }/>;

            case MODAL_TYPES.INFORM_TO_ADD_INCOME_SOURCE_MODAL:
                return <InformToAddIncomeSourceModal {...extendedProps }/>;

            case MODAL_TYPES.LEAVE_PAGE_MODAL:
                return <LeavePageModal {...extendedProps }/>;

            case MODAL_TYPES.LOCATE_ASSISTANCE_MODAL:
                return <LocateAssistanceModal {...extendedProps }/>;

            case MODAL_TYPES.MANDATORY_SEEKING_FOR_COVERAGE_MODAL:
                return <MandatorySeekingForCoverageModal { ...{ ...extendedProps, environment } }/>;

            case MODAL_TYPES.MULTI_TAX_HOUSEHOLD_MODAL:
                return <MultiTaxHouseholdModal {...extendedProps }/>;

            case MODAL_TYPES.OTHER_ADDRESS_MODAL:
                return <OtherAddressModal {...{ ...extendedProps, actions: { ...actions, ...actionsForOtherAddressModal } }}/>;

            case MODAL_TYPES.REMOVE_MEMBER_MODAL:
                return <RemoveMemberModal { ...{ ...extendedProps, environment } }/>;

            case MODAL_TYPES.SSAP_EXIT_MODAL:
                return <SsapExitModal  {...extendedProps }/>;

            case MODAL_TYPES.UNDO_MEMBER_REMOVAL_MODAL:
                return <UndoMemberRemovalModal { ...extendedProps } />;

            case MODAL_TYPES.VALIDATE_ADDRESS_MODAL:
                return <ValidateAddressModal {...extendedProps }/>;
                
                // For testing only:

            case MODAL_TYPES.EXTRA_MODAL:
                return <ExtraModal {...extendedProps } />;
        }
    };

    return getModal();
};

const mapStateToProps = state => ({
    environment: state.common.environment,

    adjustedFlow: state.ssap.adjustedFlow,
    counties: state.ssap.counties,
    data: state.ssap.data,
    form: state.ssap.form,

    householdMembers: state.ssap
        .data
        .taxHousehold
        .householdMember,

    hyperReview: state.ssap.hyperReview,
    methods: state.ssap.methods,
    page: state.ssap.page,
});

const mapDispatchToProps = dispatch => ({
    ssapActions: bindActionCreators({
        changeData,
        fetchCountiesForZipcode,
        setCounty
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SsapModalContainer);
